import React, { useState, useEffect } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import VideoAnalyticsContent from './VideoAnalyticsContent ';
import AudioAnalyticsContent from './AudioAnalyticsContent';
import TextAnalyticsContent from './TextAnalyticsContent';
import { IoAnalyticsOutline } from "react-icons/io5";

const RightSection = ({ resultData, mode }) => {
  const [activeTab, setActiveTab] = useState('audio'); // Default to 'audio'
  const [videoData, setVideoData] = useState(null);
  const [audioData, setAudioData] = useState(null);
  const [textData, setTextData] = useState(null);

  useEffect(() => {
    if (resultData) {
      setVideoData(resultData.video_analysis);
      setAudioData(resultData.audio_analysis);
      setTextData(resultData.text_analysis);

      console.log('Right section mode : ', mode)
      // Set initial active tab based on mode and available data
      if (mode === 'audio') {
        if (resultData.audio_analysis && Object.keys(resultData.audio_analysis).length > 0) {
          setActiveTab('audio');
        } else if (resultData.text_analysis && Object.keys(resultData.text_analysis).length > 0) {
          setActiveTab('text');
        }
      } else if (mode === 'fm' || mode === 'bm') { // Explicitly handle 'fm' and 'bm' modes
        // For 'fm' or 'bm' modes, prioritize Video, then Audio
        if (resultData.video_analysis && Object.keys(resultData.video_analysis).length > 0) {
          setActiveTab('video');
        } else if (resultData.audio_analysis && Object.keys(resultData.audio_analysis).length > 0) {
          setActiveTab('audio');
        }
      } else { // For other modes (e.g., 'hybrid' or general video mode with text)
        // Prioritize 'video' tab if video data is present
        if (resultData.video_analysis && Object.keys(resultData.video_analysis).length > 0) {
          setActiveTab('video');
        } else if (resultData.audio_analysis && Object.keys(resultData.audio_analysis).length > 0) {
          // If no video, but audio data exists, default to 'audio'
          setActiveTab('audio');
        }
      }
    }
  }, [resultData, mode]); // Depend on resultData and mode to re-evaluate

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="border border-gray-300 rounded-lg py-2 flex flex-col"> {/* Removed h-full */}
      <div className="flex justify-around items-center px-4 pt-2">
        {/* Conditional rendering of tabs based on the 'mode' prop */}
        {mode === 'audio' ? (
          <>
            {/* Tabs for 'audio' mode: Audio and Text */}
            {audioData && Object.keys(audioData).length > 0 && (
              <button
                onClick={() => handleTabChange('audio')}
                className={`flex-1 flex items-center justify-center py-4 px-2 text-lg font-semibold mb-2 mx-1
                  ${activeTab === 'audio' ? 'bg-[#FCF6E5] text-[#303972] rounded-xl' : 'text-[#303972]'}
                  transition-colors duration-200 ease-in-out`}
              >
                Audio Analytics {activeTab === 'audio' ? (<IoAnalyticsOutline className="ml-2" />) : ''}
              </button>
            )}
            {textData && Object.keys(textData).length > 0 && (
              <button
                onClick={() => handleTabChange('text')}
                className={`flex-1 flex items-center justify-center py-4 px-2 text-lg font-semibold mb-2 mx-1
                  ${activeTab === 'text' ? 'bg-[#FCF6E5] text-[#303972] rounded-xl' : 'text-[#303972]'}
                  transition-colors duration-200 ease-in-out`}
              >
                Text Analytics {activeTab === 'text' ? (<IoAnalyticsOutline className="ml-2" />) : ''}
              </button>
            )}
          </>
        ) : (
          <>
            {/* Tabs for non-'audio' modes: Video, Audio, (and Text if not 'fm' or 'bm') */}
            {videoData && Object.keys(videoData).length > 0 && (
              <button
                onClick={() => handleTabChange('video')}
                className={`flex-1 flex items-center justify-center py-4 px-2 text-lg font-semibold mb-2 mx-1
                ${activeTab === 'video' ? 'bg-[#FCF6E5] text-[#303972] rounded-xl' : 'text-[#303972]'}
                transition-colors duration-200 ease-in-out`}
              >
                Video Analytics {activeTab === 'video' ? (<IoAnalyticsOutline className="ml-2" />) : ''}
              </button>
            )}
            {audioData && Object.keys(audioData).length > 0 && (
              <button
                onClick={() => handleTabChange('audio')}
                className={`flex-1 flex items-center justify-center py-4 px-2 text-lg font-semibold mb-2 mx-1
                  ${activeTab === 'audio' ? 'bg-[#FCF6E5] text-[#303972] rounded-xl' : 'text-[#303972]'}
                  transition-colors duration-200 ease-in-out`}
              >
                Audio Analytics {activeTab === 'audio' ? (<IoAnalyticsOutline className="ml-2" />) : ''}
              </button>
            )}
            {/* Text Analytics tab is conditionally rendered for non-audio modes, but excluded for 'fm' and 'bm' */}
            {textData && Object.keys(textData).length > 0 && mode !== 'fm' && mode !== 'bm' && (
              <button
                onClick={() => handleTabChange('text')}
                className={`flex-1 flex items-center justify-center py-4 px-2 text-lg font-semibold mb-2 mx-1
                  ${activeTab === 'text' ? 'bg-[#FCF6E5] text-[#303972] rounded-xl' : 'text-[#303972]'}
                  transition-colors duration-200 ease-in-out`}
              >
                Text Analytics {activeTab === 'text' ? (<IoAnalyticsOutline className="ml-2" />) : ''}
              </button>
            )}
          </>
        )}
      </div>

      <div className="flex-grow overflow-auto"> {/* Changed flex-1 to flex-grow and kept overflow-auto */}
        {/* Conditional rendering of content based on activeTab */}
        {activeTab === 'video' && videoData ? (
          <VideoAnalyticsContent videoData={videoData} />
        ) : activeTab === 'audio' && audioData ? (
          <AudioAnalyticsContent audioData={audioData} textData={textData} mode={mode} />
        ) : activeTab === 'text' && textData ? (
          <TextAnalyticsContent textData={textData} audioData={audioData} />
        ) : (
          <p className="p-4 text-center text-gray-600">No analytics data available for the selected tab.</p>
        )}
      </div>
    </div>
  );
};

export default RightSection;